module.exports = __webpack_public_path__ + "static/img/medal2.537af00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/medal2.png
// module id = 4DQQ
// module chunks = 1